class Loadmore extends HTMLElement {
    constructor() {
        super();
        this.nextUrl = this.dataset.next;
        this.currentPage = this.dataset.current;
        this.totalPages = this.dataset.pages;
        this.url = this.dataset.url;
        this.wrapperClass = this.dataset.wrapperClass;
        this.subWrapperClass = this.dataset.subWrapperClass;
        this.gridItemClass = this.dataset.gridItemClass;
        this.button = this.querySelector(".js-load-more");
        this.productItem = null;
        this.totalItems = this.dataset.itemNumber;
        this.showItemPerPage = this.dataset.showItemPerPage ?? 'true';
        this.itemPerPage = parseInt(this.dataset.itemPerPage);
        this.pageStored = parseInt(localStorage.getItem('currentPage'));
        // this.currentDomain=this.dataset.currentDomain;
       
    }

    connectedCallback() {
        // if (localStorage.getItem('currentPage') && parseInt(localStorage.getItem('currentPage')) > 1) {
            // this.renderProduct();
        // }
        this.listener();
        this.itemPerPage = 0;
        document.querySelector(`.${this.wrapperClass}`).querySelectorAll(`.${this.subWrapperClass}`).forEach((element) => {
            for(let i=0;i<element.children.length;i++){
                if(!element.children[i].classList.contains('grid__item-image')){
                    this.itemPerPage++;
                }
            }
        })
        //remove the last product item and save it in the load more 
        
        if (this.dataset.image == "true" && this.currentPage != this.totalPages) {
            this.productItem = this.previousElementSibling.removeChild(this.previousElementSibling.lastChild);
            this.itemPerPage--;
        }
        
        this.dataset.itemPerPage = this.itemPerPage;
        if (this.showItemPerPage === 'true') {
            this.querySelector('.item_per_page').innerText = this.itemPerPage
        }
        // let prodToscroll=document.querySelector(`[data-product-id="${localStorage.getItem('prodId')}"]`)
        // if(prodToscroll){
        //     window.scrollTo(0,prodToscroll.getBoundingClientRect().top);
        //     this.emptyLocalStorage();
        // }
            
    }

    listener() {
        this.button.addEventListener('click', () => { this.loadProduct() })
        // window.addEventListener('popstate',(event)=>{console.log(event.state.currentPage)})
        //document.querySelector('.collection').querySelectorAll('.product-grid').forEach((element) => {
        //    element.querySelectorAll('.grid__item').forEach((element)=>{
        //        element.addEventListener('click',(e)=>this.productSelected(e));
        //    })
            // element.addEventListener('click', (e) => this.productSelected());
        //})

    }

    loadProduct() {
        if (parseInt(this.currentPage) >= parseInt(this.totalPages)) {
            this.querySelector('[load-more-text]').innerText = 'Products Finished';
        } else {
            this.querySelector('[load-more-text]').classList.add('hide');
            document.querySelector(`.${this.wrapperClass}`).classList.add("loading");
            document.querySelector(`.${this.wrapperClass}`).removeChild(this)
            fetch(this.nextUrl)
                .then(function (response) {
                    return response.text();
                })
                .then(function (html) {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, 'text/html');

                    // Insert new content
                    let newLoadMore = doc.querySelector(`.${this.wrapperClass}`).lastChild;
                    let newGrid = doc.querySelector(`.${this.wrapperClass} .${this.subWrapperClass}`);

                    //Add last element of the previus grid as first element of the new grid
                    if (this.dataset.image == "true") {
                        this.productItem.style="--animation-order: 1"
                        newGrid.insertBefore(this.productItem, newGrid.firstChild);
                    }
                    let newGridItems = newGrid.querySelectorAll(`.${this.gridItemClass}`);
                    // Append grid items to the current grid
                    let firstItem = newGridItems[0];
                    newGridItems.forEach((newItem, index) => {
                        document.querySelector(`.${this.wrapperClass} .${this.subWrapperClass}`).appendChild(newItem);
                    });
                    firstItem.querySelector('fieldset input').focus();
                    // document.querySelector('.collection').appendChild(newGrid);
                    //Apply the css classes to the new load more
                    if (parseInt(this.currentPage) + 1 >= parseInt(this.totalPages)) {
                        newLoadMore.querySelector('[load-more-text]').innerText = 'Products Finished';
                        //newLoadMore.querySelector('[load-more-text]').classList.remove("hide");
                        newLoadMore.querySelector('.js-load-more').classList.add("tw-hidden");
                        newLoadMore.querySelector('.js-load-more').setAttribute('disabled', true);
                    }
                    //Append the new laod more button to the grid in oreder to refresh the custom element
                    document.querySelector(`.${this.wrapperClass}`).appendChild(newLoadMore)
                }
                .bind(this))// Ensure 'this' refers to the custom element
                .catch(function (err) {
                    console.warn('Something went wrong.', err);
                })
                .finally(() => {
                        document.querySelector(`.${this.wrapperClass}`).classList.remove("loading");
                })
        }
    }
    // productSelected(e) {
    //     let pId=e.currentTarget.dataset.productId;
    //     // if(this.currentPage>1){
    //     //     localStorage.setItem('nextUrl',this.nextUrl);
    //     //     localStorage.setItem('currentPage',this.currentPage)
    //     //     localStorage.setItem('prodId',pId);
    //     // }
    // }
    // renderProduct() {
    //     console.log("render")
    //     let nPage=new URL(this.currentDomain+localStorage.getItem('nextUrl')).searchParams.get('page');
    //     localStorage.removeItem('currentPage')
    //     localStorage.removeItem('nextUrl')
    //     let listaUlr=[];
    //     for(let i=2;i<nPage;i++){
    //         listaUlr.push(this.nextUrl.replace(/page=(?:[1-9]|[1-9][0-9])$/,'page='+i))   
    //     }
    //     Promise.all(listaUlr.map(url => fetch(url).then((res)=>{return res.text()})))
    //     .then((results)=> {
    //         // console.log(results)
    //         //remove this load more from the current collection
    //         let collectionBase=document.querySelector('.collection');
    //         collectionBase.removeChild(this)
    //         let newLoadMore=null;
    //         results.forEach((element)=>{
    //             let parser = new DOMParser();
    //             let doc = parser.parseFromString(element, 'text/html');
    //             // Insert new content
    //             newLoadMore = doc.querySelector('.collection').querySelector('load-more');
    //             let newGrid = doc.querySelector('.collection .product-grid');
    //             if (this.dataset.image == "true" && this.currentPage != this.totalPages) {
    //                 newGrid.insertBefore(this.productItem, newGrid.firstChild);
    //                 this.productItem=newGrid.removeChild(newGrid.lastChild);
    //             }
    //             //Insert new grid to content 
    //             collectionBase.appendChild(newGrid);
    //         })
    //         //Insert the load more of the last result
    //         if (this.dataset.image == "true" && this.currentPage != this.totalPages){
    //              collectionBase.lastChild.appendChild(this.productItem)
    //         }
    //         collectionBase.appendChild(newLoadMore);
    //     })

    // }
    // emptyLocalStorage(){
    //     localStorage.removeItem('prodId')
    //     localStorage.removeItem('nextUrl')
    //     localStorage.removeItem('currentPage')
    // }
}

customElements.define('load-more', Loadmore);